import React from 'react';
import { useSelector } from 'react-redux';
import s from './index.module.scss';
import logo from './img/logo_progress.svg';

function Divider() {
	return (
		<div className={s.progressBar_divider}>
			<div className={s.progressBar_divider_dot} />
			<div className={s.progressBar_divider_dot} />
			<div className={s.progressBar_divider_dot} />
			<div className={s.progressBar_divider_dot} />
		</div>
	);
}

function ProgressBar() {
	const currentStepIndex = useSelector(state => state.steps.currentStepIndex);
	const totalSteps = useSelector(state => state.steps.totalSteps);

	return (
		<div className={s.progressBar_wrapper}>
			<div className={s.progressBar} style={{ '--step': currentStepIndex, '--totalSteps': totalSteps }} />
			<Divider />
			<img width={23} height={23} src={logo} className={s.progressBar_logo} alt="logo" />
		</div>
	);
}

export default ProgressBar;
